/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Skeleton, Typography, Typography2, breakpoints } from '@coursera/cds-core';

const styles = {
  card: () => css`
    min-height: 265px;
    border: 1px solid var(--cds-color-grey-50);
    box-sizing: border-box;
    box-shadow: 0 0 10px var(--cds-color-darken-200);
    border-radius: 6px;
    padding: var(--cds-spacing-400) var(--cds-spacing-300);
    margin: var(--cds-spacing-300) 0;
    display: flex;
    ${breakpoints.down('xs')} {
      min-height: 180px;
      margin: var(--cds-spacing-300) 0;
      padding: var(--cds-spacing-300) var(--cds-spacing-200);
    }
  `,
  titleSkeletonContainer: () => css`
    display: inline-block;
    width: 200px;
    ${breakpoints.down('xs')} {
      width: 150px;
    }
  `,
  imageSkeleton: () => css`
    display: inline-block;
    border: 1px solid var(--cds-color-grey-50);
    box-sizing: border-box;
    border-radius: 4px;
    padding: var(--cds-spacing-100);
    margin-right: var(--cds-spacing-100);
  `,
  contentContainer: css`
    display: flex;
  `,
  courseDetailsSkeleton: () => css`
    border-right: 1px solid var(--cds-color-grey-25);
    padding-right: var(--cds-spacing-100);

    .product-card-subtitle-skeleton {
      width: 400px;
      height: 40px;
      margin-top: var(--cds-spacing-100);
    }

    ${breakpoints.down('xs')} {
      border-right: none;

      .product-card-subtitle-skeleton {
        width: 200px;
        height: 30px;
      }
    }
  `,
  statistics: () => css`
    margin-top: var(--cds-spacing-100);
  `,
  duration: () => css`
    margin: var(--cds-spacing-150) 0 0 var(--cds-spacing-400);
    width: 30%;

    .skills-title {
      margin-top: var(--cds-spacing-300);
    }
    ${breakpoints.down('xs')} {
      display: none;
    }
  `,
};

const EntityCardPlaceholder = () => {
  return (
    <div css={styles.card} data-testid="articles_entity_card_placeholder">
      <div css={styles.contentContainer}>
        <div css={styles.courseDetailsSkeleton}>
          <div css={styles.imageSkeleton}>
            <Skeleton variant="rect" width={60} height={60} />
          </div>
          <div css={styles.titleSkeletonContainer}>
            <Typography2 component="p" variant="bodySecondary" color="supportText">
              <Skeleton />
            </Typography2>
            <Typography variant="h2semibold" component="h3">
              <Skeleton />
            </Typography>
          </div>
          <div className="product-card-subtitle-skeleton">
            <Skeleton variant="rect" />
          </div>
          <div css={styles.statistics}>
            <Skeleton variant="rect" height={30} width={300} />
          </div>

          <Skeleton height={50} />
        </div>

        <div css={styles.duration}>
          <Typography2 variant="subtitleMedium" component="p">
            <Skeleton width={200} height={20} />
          </Typography2>
          <Typography2 component="p" variant="bodySecondary" color="supportText">
            <Skeleton />
          </Typography2>
          <Typography2 variant="subtitleMedium" component="p" className="skills-title">
            <Skeleton width={200} height={40} />
          </Typography2>
          <Typography2 component="p" variant="bodySecondary" color="supportText">
            <Skeleton width={200} height={40} />
          </Typography2>
        </div>
      </div>
    </div>
  );
};

export default EntityCardPlaceholder;
